import React from 'react';
import FixedBottomNavBar from '../../../../components/FixedBottomNavBar';
import Button from '../../../../components/Button';
import './CouponSaveNavbar.scss';

const CouponSaveNavbar = (props) => {
  const { onSubmit } = props;

  return (
    <FixedBottomNavBar className="coupon-save-navbar">
      {/*저장*/}
      <Button color="primary" text="저장" onClick={() => onSubmit()} />
    </FixedBottomNavBar>
  );
};

export default CouponSaveNavbar;
